import { useEffect } from "react";

/**
 * Adds `.is-visible` to any element with `.reveal-on-scroll` once it enters the viewport.
 * Honors prefers-reduced-motion by revealing everything immediately.
 */
const useRevealOnScroll = (deps: unknown[] = []) => {
  useEffect(() => {
    const targets = document.querySelectorAll<HTMLElement>(".reveal-on-scroll:not(.is-visible)");
    if (!targets.length) return;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced || typeof IntersectionObserver === "undefined") {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useRevealOnScroll;
